export const publicationsLabel = "Eric's Publications";

export const publications = [
    {
        id: 4,
        title: "2025 HA",
        description: "Follow up observations from the Dominion Astrophysical Observatory of 2025 HA, a recently discovered NEO (first recorded observation by Pan-STARRS 1, Haleakala on 2025-04-16) and Apollo class object.",
        year: "2025",
        month: "05",
        url: "https://ui.adsabs.harvard.edu/abs/2025MPEC....H....9D/abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 0,
        title: "DAO photometric follow-up of selected transients (Oct. 2024 - II)",
        description: "We present (SDSS) g&r filter photometric follow up observations of selected optical transients obtained using the 1.82-m Plaskett telescope of the (Dominion Astrophysical Observatory) National Research Council of Canada during subsequent nights of the October 2024 dark run. ",
        year: "2024",
        month: "10",
        url: "https://ui.adsabs.harvard.edu/abs/2024TNSAN.296....1B/abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 1,
        title: "DAO photometric follow-up of selected transients (Oct. 2024)",
        description: "We present (SDSS) g&r filter photometric follow up observations of selected optical transients obtained using the 1.82-m Plaskett telescope of the (Dominion Astrophysical Observatory) National Research Council of Canada during the October 2024 dark run.",
        year: "2024",
        month: "10",
        url: "https://ui.adsabs.harvard.edu/abs/2024TNSAN.283....1B/abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 11,
        title: "Comet P/2024 s2 (rankin)",
        description: "...the magnitude was 18.2 as measured within a circular aperture of radius 7'.6. D. D. Balam, Dominion Astrophysical Observatory (DAO), reports that thirty-one 60-s exposures taken on Oct. 2.52 with the 1.82-m Plaskett telescope at DAO (National Research Council of Canada) by Balam (in collaboration with C. E. Spratt, E. Hess, and D. W. E. Green) in 4''.1 seeing show a coma of size 5''.6 through an SDSS g' filter.",
        year: "2024",
        month: "10",
        url: "https://ui.adsabs.harvard.edu/abs/2024CBET.5457....1R/abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 2,
        title: "DAO photometric follow-up of selected transients",
        description: "We present photometric follow up observations of selected optical transients obtained using the 1.82-m Plaskett telescope of the (Dominion Astrophysical Observatory) National Research Council of Canada",
        year: "2024",
        month: "09",
        url: "https://ui.adsabs.harvard.edu/abs/2024TNSAN.249....1B/abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 3,
        title: "DAO photometric follow-up of selected transients (Aug. 2024) ",
        description: "Here we present photometric follow up observations of selected optical transients obtained using the 1.82-m Plaskett telescope of the (Dominion Astrophysical Observatory) National Research Council of Canada during the Aug. 2024 dark run. ",
        year: "2024",
        month: "08",
        url: "https://ui.adsabs.harvard.edu/abs/2024TNSAN.223....1B/abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 5,
        title: "DAO photometric follow-up of selected transients",
        description: "Here we present photometric follow up observations of selected optical transients obtained using the 1.82-m Plaskett telescope of the (Dominion Astrophysical Observatory) National Research Council of Canada.",
        year: "2024",
        month: "08",
        url: "https://ui.adsabs.harvard.edu/abs/2024TNSAN.213....1B/abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 6,
        title: "2024 PZ5",
        description: "Follow up observations of 2024 PZ5 (Initial reported observation by Pan-STARRS 1, Haleakala on 2024-08-13) from the Dominion Astrophysical Observatory.",
        year: "2024",
        month: "08",
        url: "https://ui.adsabs.harvard.edu/abs/2024MPEC....P..176W/abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 7,
        title: "2024 PY5",
        description: "Follow up observations of 2024 PY5 (Initial reported observation by Pan-STARRS 1, Haleakala on 2024-08-13) from the Dominion Astrophysical Observatory.",
        year: "2024",
        month: "08",
        url: "https://ui.adsabs.harvard.edu/abs/2024MPEC....P..175G/abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 8,
        title: "Observations and Orbits of Comets and a/ Objects",
        description: "",
        year: "2024",
        month: "08",
        url: "https://ui.adsabs.harvard.edu/abs/2024MPEC....P..125P/abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 9,
        title: "Observations and Orbits of Comets and a/ Objects",
        description: "",
        year: "2024",
        month: "08",
        url: "https://ui.adsabs.harvard.edu/abs/2024MPEC....P...23./abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 10,
        title: "DAO photometric follow-up of selected optical transients",
        description: "Here we present photometric follow up observations of selected optical transients using 1.82-m Plaskett telescope of the Dominion Astrophysical Observatory (HAA) National Research Council of Canada.",
        year: "2024",
        month: "07",
        url: "https://ui.adsabs.harvard.edu/abs/2024TNSAN.212....1B/abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 12,
        title: "Daily Orbit Update (2024 July 26)",
        description: "Joint publication. Daily orbit update across multiple observing teams for the Minor Planet Centre.",
        year: "2024",
        month: "07",
        url: "https://ui.adsabs.harvard.edu/abs/2024MPEC....O...58./abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 13,
        title: "2024 NN3",
        description: "Observations of near-Earth object 2024 NN3.",
        year: "2024",
        month: "07",
        url: "https://ui.adsabs.harvard.edu/abs/2024MPEC....O....3R/abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 14,
        title: "Observations and Orbits of Comets and a/ Objects",
        description: "Joint observations of multiple comets and asteroids.",
        year: "2024",
        month: "07",
        url: "https://ui.adsabs.harvard.edu/abs/2024MPEC....N..144S/abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 15,
        title: "DAO & RAO photometric follow-up of selected transients",
        description: "Here we present photometric follow up observations of selected optical transients using 0.76-m Baker-Nunn Schmidt Telescope + CCD at Rothney Astrophysical Observatory of the University of Calgary and the 1.82-m Plaskett telescope of the (Dominion Astrophysical Observatory) National Research Council of Canada.",
        year: "2024",
        month: "06",
        url: "https://ui.adsabs.harvard.edu/abs/2024TNSAN.163....1B/abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 16,
        title: "Multi-filter & multi-site follow-up of selected transients",
        description: "Here we present photometric follow up observations of selected optical transients using 0.76-m Baker-Nunn Schmidt Telescope + CCD at Rothney Astrophysical Observatory of the University of Calgary and the 1.82-m Plaskett telescope of the (Dominion Astrophysical Observatory) National Research Council of Canada.",
        year: "2024",
        month: "06",
        url: "https://ui.adsabs.harvard.edu/abs/2024TNSAN.156....1H/abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 17,
        title: "RAO Photometric Follow Up of Three Optical Transients",
        description: "Here we present photometric follow up observations of 3 optical transients using 0.76-m Baker-Nunn Schmidt Telescope + CCD at Rothney Astrophysical Observatory of the University of Calgary.",
        year: "2024",
        month: "06",
        url: "https://ui.adsabs.harvard.edu/abs/2024TNSAN.152....1H/abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 18,
        title: "Observations and Orbits of Comets and a/ Objects",
        description: "Joint observations of comets and aasteroids.",
        year: "2024",
        month: "06",
        url: "https://ui.adsabs.harvard.edu/abs/2024MPEC....M...41K/abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 19,
        title: "A/2024 W2",
        description: "Observations of asteroid 2024 W2",
        year: "2024",
        month: "nn",
        url: "https://ui.adsabs.harvard.edu/abs/2024MPEC....Y..249S/abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 20,
        title: "2024 WY70",
        description: "Observations of asteroid 2024 WY70",
        year: "2024",
        month: "nn",
        url: "https://ui.adsabs.harvard.edu/abs/2024MPEC....X..283R/abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 21,
        title: "Observations and Orbits of Comets and a/ Objects",
        description: "Joint observations of comets and asteroids.",
        year: "2024",
        month: "nn",
        url: "https://ui.adsabs.harvard.edu/abs/2024MPEC....U..109D/abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 22,
        title: "Observations and Orbits of Comets and a/ Objects",
        description: "Joint observations of comets and asteroids.",
        year: "2024",
        month: "nn",
        url: "https://ui.adsabs.harvard.edu/abs/2024MPEC....U...18L/abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 23,
        title: "COMET P/2024 T2 (Rankin)",
        description: "",
        year: "2024",
        month: "nn",
        url: "https://ui.adsabs.harvard.edu/abs/2024MPEC....U...16L/abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 24,
        title: "COMET P/2024 S2 (Rankin)",
        description: "Original observation of comet P/2024 T2 (Rankin) that was later cited in a CBET in October 2024.",
        year: "2024",
        month: "nn",
        url: "https://ui.adsabs.harvard.edu/abs/2024MPEC....T..259R/abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 25,
        title: "2024 SX6",
        description: "Observations of asteroid 2024 SX6",
        year: "2024",
        month: "nn",
        url: "https://ui.adsabs.harvard.edu/abs/2024MPEC....T...12F/abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 26,
        title: "Comet P/2024 r3 (panstarrs)",
        description: "Observations of comet P/2024 r3 (panstarrs)",
        year: "2024",
        month: "nn",
        url: "https://ui.adsabs.harvard.edu/abs/2024MPEC....S...11H/abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 27,
        title: "Comet P/2024 q1 (panstarrs)",
        description: "Observations of comet P/2024 q1 (panstarrs)",
        year: "2024",
        month: "nn",
        url: "https://ui.adsabs.harvard.edu/abs/2024MPEC....Q...87M/abstract",
        hostedBy: "NASA ADS",
    },
    {
        id: 28,
        title: "Observations and Orbits of Comets and a/ Objects",
        description: "Joint observations of comets and asteroids.",
        year: "2024",
        month: "nn",
        url: "https://ui.adsabs.harvard.edu/abs/2024MPEC....Q...20F/abstract",
        hostedBy: "NASA ADS",
    },
]